module.exports = __webpack_public_path__ + "static/img/img-cp3.1c9571a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp3.png
// module id = ejVu
// module chunks = 0